import companyRestService from '../services/company/CompanyRestService'
import companyFunctions from '../services/company/CompanyUtilsFunctions'
import { upsertCatalogOption } from '../services/common/CatalogOptions'

const state = {
  companies: [],
  basicCompanies: [],
  baseCompanies: [],
  resposibleType: [],
  filteredCompanies: [],
  dialogActived: false,
  selectedItem: {
    id: -1,
    cuit: '',
    location: {},
    responsibleType: {},
    phone: '',
    mail: '',
    obs: ''
  }
}

const getters = {
  getCompanies: state => state.companies,
  getBaseCompanies: state => state.baseCompanies,
  getResposibleType: state => state.resposibleType,
  isDialogActived: state => state.dialogActived,
  getSelectedItem: state => state.selectedItem,
  getFilteredCompanies: state => state.filteredCompanies,
  getBasicCompaniesInfo: state => state.basicCompanies
}

const actions = {
  async getCompanies (context) {
    try {
      let data = await companyRestService.getCompanies()
      context.commit('setCompanies', data)
    } catch (error) {
      console.log('Error fetching companies')
    }
  },
  async getBasicCompaniesInfo (context) {
    try {
      let data = await companyRestService.getBasicCompaniesInfo()
      context.commit('setBasicCompaniesInfo', data)
    } catch (e) {
      console.log('Error fetching basic Companies')
    }
  },
  async getBaseCompanies (context) {
    try {
      let data = await companyRestService.getBaseCompanies()
      context.commit('setBaseCompanies', data)
    } catch (e) {
      console.log('Error fetching base Companies')
    }
  },
  async getResposibleType (context) {
    try {
      let data = await companyRestService.getResposibleType()
      context.commit('setResponsibleType', data)
    } catch (error) {
      console.log('Error fetching ResposibleTypes')
    }
  },
  async saveCompany (context, companyInfo) {
    let snackBarContent = {actived: true, message: 'Entidad Comercial Agregada Exitosamente.', color: 'success'}
    try {
      const saved = await companyRestService.saveCompany(companyInfo)
      context.commit('upsertCompany', saved)
      context.commit('setSnackBarStatus', snackBarContent, {root: true})
      return saved
    } catch (error) {
      snackBarContent = {actived: true, message: 'Error agregando Entidad Comercial.', color: 'error'}
      context.commit('setSnackBarStatus', snackBarContent, {root: true})
      throw error
    }
  },
  async removeCompany (context, id) {
    let snackBarContent = {actived: true, message: 'Entidad Comercial Eliminada Exitosamente.', color: 'success'}
    try {
      await companyRestService.removeCompany(id)
      context.commit('setSnackBarStatus', snackBarContent, {root: true})
    } catch (error) {
      if (error.response.status === 424) {
        let notiDialogValue = {
          actived: true,
          title: 'Imposible borrar el item seleccionado',
          body: companyFunctions.getDependenciesMsg(error.response.data) }
        context.commit('setNotificationDialog', notiDialogValue, {root: true})
      } else {
        snackBarContent = {actived: true, message: 'Error Eliminando Entidad Comercial.', color: 'error'}
        context.commit('setSnackBarStatus', snackBarContent, {root: true})
      }
    }
  },
  setDialogActived (context, active) {
    context.commit('setDialogActived', active)
  },
  setSelectedItem (context, selectedItem) {
    context.commit('setSelectedItem', selectedItem)
  },
  filterItems (context, filters) {
    context.commit('filterCompany', filters)
  },
  refreshFilteredCompanies (context) {
    context.commit('refreshFilteredCompanies')
  }
}

const mutations = {
  upsertCompany (state, saved) {
    for (const items of new Set([state.companies, state.baseCompanies, state.basicCompanies, state.filteredCompanies])) {
      upsertCatalogOption(items, saved)
    }
  },
  setCompanies (state, data) {
    state.companies = data
  },
  setBasicCompaniesInfo (state, data) {
    state.basicCompanies = data
  },
  setBaseCompanies (state, data) {
    state.baseCompanies = data
  },
  setDialogActived (state, active) {
    state.dialogActived = active
  },
  setSelectedItem (state, selectedItem) {
    state.selectedItem = selectedItem
  },
  setResponsibleType (state, data) {
    state.resposibleType = data
  },
  filterCompany (state, filters) {
    state.filteredCompanies = companyFunctions.filterCompanies(state.companies, filters)
  },
  refreshFilteredCompanies (state) {
    state.filteredCompanies = state.companies
  }
}
export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
